import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../app/context";
import { useNavigate } from "react-router-dom";
import AdminDashboardLayout from "../layout/AdminDashboardLayout";
import { Table } from "react-bootstrap";
import axios from "axios";
import PasswordModal from "./passwordModal";

const AcountSettings = () => {
  const apiUrl = process.env.REACT_APP_BACKEND_API;
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [selectedUser, setSelectedUser] = useState({});
  const [show, setShow] = useState(false);
  const [users, setUsers] = useState([]);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const resp = await axios.get(`${apiUrl}/admin-dashboard/get-all-user`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setUsers(resp.data.users);
      } catch (error) {
        if (error.response.data?.message === "Invalid Token") {
          navigate("/signin");
        }
        console.log(error.response.data);
      }
    };
    fetchUsers();
  }, []);
  const handlePasswordUpdate = (user) => {
    setSelectedUser(user);
    handleShow();
  };
  const handleClose = () => {
    setSelectedUser({});
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  return (
    <AdminDashboardLayout>
      <>
        <h4 className="text-center p-2">User Accounts</h4>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users?.map((user, index) => {
              return (
                <tr key={user._id}>
                  <td>{index + 1}</td>
                  <td>{user.userName}</td>
                  <td>{user.email}</td>
                  <td
                    className="pointer text-blue"
                    onClick={() => handlePasswordUpdate(user)}
                  >
                    change password
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </>
      <PasswordModal
        selectedUser={selectedUser}
        show={show}
        handleClose={handleClose}
      />
    </AdminDashboardLayout>
  );
};

export default AcountSettings;
